import { createApi } from '@reduxjs/toolkit/query/react';

import { apiFundingLevelAmounts } from '~constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { FundingLevelAmount } from '~lookups/models';

export const fundingLevelAmountsApi = createApi({
  reducerPath: 'fundingLevelAmountsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiFundingLevelAmounts }),
  tagTypes: ['funding-level-amounts'],
  endpoints: (builder) => ({
    getFundingLevelAmounts: builder.query<FundingLevelAmount[], Request | void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: [{ type: 'funding-level-amounts', id: 'LIST' }],
      transformResponse: (payload) => unwrap<FundingLevelAmount[]>(payload),
    }),
  }),
});

export const { useGetFundingLevelAmountsQuery } = fundingLevelAmountsApi;
